export default "__VITE_ASSET__De08EfqY__"